const sortsBefore = (address0, address1) =>
	address0.toLowerCase() < address1.toLowerCase();

export default sortsBefore;
